import React from 'react'
import { PropTypes } from 'prop-types'
import ErrorBoundary from './error'
import UserList from './components/UserList'

const Users = props => (
    <ErrorBoundary>
        <UserList displayLoginWindow={props.displayLoginWindow} />
    </ErrorBoundary>
)

Users.propTypes = {
    displayLoginWindow: PropTypes.func,
}

export default Users

export { usersReducer, middleware, constants, actions, selectors } from './exports'



// WEBPACK FOOTER //
// ./src/features/Users/index.js